<template>
  <div class="TodayPage">

    <el-button type="primary" plain class="d-block w-100 my-4" @click="onGoBack">
      <i class="el-icon-back"></i> Go back
    </el-button>

    <h4>Set todays priorities</h4>

    <!-- TODO: 'today mode' -->
    <TimeslotCollectionMultiDragList mode="commitment" />

    <!-- TODO: show unassigned too? -->

    <!-- <router-link to='/today/goals'>today</router-link> | -->
    <!-- <router-link to='/today/priorities'>priorities</router-link> -->

  </div>
</template>

<script>
import TimeslotCollectionMultiDragList from '@/components/CalendarPage/Timeslots/TimeslotCollectionMultiDragList';

export default {
  name: "MyDailyPriorities_Subpage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
    onGoBack() {
      this.$router.push('/today/goals')
    }
  },
  components: {
    TimeslotCollectionMultiDragList
  }
}
</script>

<style>
</style>
